export enum SubscriptionKind {
  STRIPE = "stripe",
  GOOGLE_PLAY = "google_play",
  AMAZON = "amazon",
  SAMSUNG_IAP = "samsungiap",
  PARTNER = "partner",
  POST = "post",
  AIS = "ais",
  A1 = "a1",
  SWISSCOM = "swisscom",
  DREI = "drei",
  CELCOM = "celcom",
  M1 = "m1",
  SMART_AXIATA = "smart_axiata",
  ORANGE_JORDAN = "orange_jordan",
  CTM = "ctm",
  VECTRA = "vectra",
  MORATELINDO = "moratelindo",
  STC = "stc",
  WISTER = "wister",
  VIRGIN_MOBILE = "virgin_mobile",
  TELEKOM_MALAYSIA = "telekom_malaysia",
  HKT = "hkt",
  GTPL = "gtpl",
  HATHWAY = "hathway",
  ZAIN = "zain_iraq",
  VIVO = "vivo",
  LG = "lg",
}
